angular.module('exportService', ['constants'])
.factory('exportService', function($http, $q, myConfig) {

  var service = {};

  var _baseUrl = myConfig.apiUrl + 'rings/euring'; //'http://127.0.0.1:8000/v1/rings/';

  /*
  * send oblist
  */
  service.generateEuring = function(scheme){
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl;
    if (scheme === 'SKB') {
      url += '_sk'
    }
    // send
    $http({
      method  : 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get ces matrix
  */
  service.getEuringStatus = function(scheme){
    var deferred = $q.defer();
    // get hashed name and password
    var userToken = localStorage.getItem('userToken');
    // complete url
    var url = _baseUrl + "?status=1";
    if (scheme === 'SKB') {
      url += '_sk'
    }
    // send
    $http({
      method : 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  return service;

});
